import { render } from "./builderComponent.vue?vue&type=template&id=ab69adc2&scoped=true"
import script from "./builderComponent.vue?vue&type=script&lang=js"
export * from "./builderComponent.vue?vue&type=script&lang=js"

import "./builderComponent.vue?vue&type=style&index=0&id=ab69adc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab69adc2"]])

export default __exports__